module.exports = __webpack_public_path__ + "img/cxTrends-3.15be9a89.png";